// Duits (de-DE), timePicker: zelfde vorm als timePicker.nl.ts. Wat ontbreekt valt terug op het
// Nederlands (nooit een rauwe sleutel op het scherm).
export const appTimePickerDe = {
    open: '{label}: Uhrzeit wählen',
    hourStep: 'Wähle die Stunde',
    minuteStep: 'Wähle die Minuten',
    hours: 'Stunden',
    minutes: 'Minuten',
    showNight: 'Nacht 00–05',
    back: 'Andere Stunde',
    close: 'Schließen',
    type: 'Selbst tippen',
    invalid: 'Das ist keine Uhrzeit. Tippe zum Beispiel 15:30 oder 930.',
    beforeStart: 'Wähle eine Zeit nach {start}.',
    endClamped: 'Ende auf 23:59 gekürzt.',
    durations: 'Wie lange dauert es?',
    orPickEnd: 'Oder wähle eine Endzeit',
    durationUntil: '{duration}, bis {time}',
    minutesShort: '{count} Min.',
    hoursShort: { one: '{count} Std.', other: '{count} Std.' },
};
//# sourceMappingURL=timePicker.de.js.map